<mat-card-content *ngIf="noStats==true">
  <p style="margin: 20px 0px 5px 0px;">
    Usage statistics not yet available. <br><br>
    Please check again tomorrow.
  </p>
</mat-card-content>




<mat-card-content class="stats-area" *ngIf="noStats==false">
  <div class="row" style="padding-top: 15px;">
    <div class="col-md">
      <div class="stat-icon-base">
        <div class="stat-icon sp-background">
          <span class="material-icons-outlined" style="color:#fff; font-size: 36px;">person</span>
        </div>
      </div>
      <div class="stat-display-block-new mat-elevation-z2 sp-border stat-block-icon">
        <div class="stat-display-title-new" style="color:#000000DE">
          Company Users <br>
          <div class="stat-display-subtitle-new">Active in last 30 days</div>
        </div>
        <div class="stat-display-stat-new stat-bold">
          {{userTotal}}
        </div>
      </div>
    </div>
    <div class="col-md">
      <div class="stat-icon-base">
        <div class="stat-icon sp-background">
          <span class="material-icons-outlined" style="color:#fff; font-size: 36px;">storage</span>
        </div>
      </div>
      <div class="stat-display-block-new mat-elevation-z2 sp-border stat-block-icon">
        <div class="stat-display-title-new" style="color:#000000DE">
          Storage <br>
          <div class="stat-display-subtitle-new">Total</div>
        </div>
        <div class="stat-display-stat-new stat-bold">
          {{storageTotal | number:'1.1-1'}}GB
        </div>
      </div>
    </div>
    <div class="col-md">
      <div class="stat-icon-base">
        <div class="stat-icon sp-background">
          <span class="material-icons-outlined" style="color:#fff; font-size: 36px;">groups</span>
        </div>
      </div>
      <div class="stat-display-block-new mat-elevation-z2 sp-border stat-block-icon">

        <div class="stat-display-title-new" style="color:#000000DE">
          Recipients<br>
          <div class="stat-display-subtitle-new">Total</div>
        </div>
        <div class="stat-display-stat-new stat-bold">
          {{recipientTotal}}
        </div>
      </div>
    </div>

    <!-- <div class="col-md">
        <div class="stat-display-block-new sp-background">
          <div class="stat-display-title-new">
            Monthly retail price:
          </div>
          <div class="stat-display-stat-new">
            {{monthlyRetailPrice | currency : 'GBP' : true : '1.2-2'}}
          </div>
        </div>
      </div>  -->
  </div>

  <div class="row">    
    <div class="col-md" style="flex-grow: 2.07;">
      <!-- <div class="stat-icon-base">
        <mat-icon class="stat-icon sp-color sp-border" style="background-color: #fff;">send</mat-icon>
      </div> -->
      <div class="stat-icon-base">
        <div class="stat-icon sp-border" style="background-color: #fff; border: solid 1px;">
          <span class="material-icons-outlined sp-color" style="font-size: 36px;">send</span>
        </div>
      </div>
      <div
        class="stat-display-block-new stat-display-overwrite sp-background mat-elevation-z2 sp-border stat-block-large"
        style="color:#fff;">
        <div class="stat-display-title-new " style="font-size: 1.65em; font-weight: 300;">
          Emails sent
        </div>
        <div class="solid-stat-block">
          <div class="sent-stat-block stat-seperator">
            <div class="sent-stat-number sp-bold">{{emailSent24h}}</div><br>
            in last 24 hours
          </div>
          <div class="sent-stat-block stat-seperator">
            <div class="sent-stat-number sp-bold">{{emailSent7d}}</div><br>
            in last 7 days
          </div>
          <div class="sent-stat-block stat-seperator">
            <div class="sent-stat-number sp-bold">{{emailSent30d}}</div><br>
            in last 30 days
          </div>
          <div class="sent-stat-block">
            <div class="sent-stat-number sp-bold">{{emailSentTotal}}</div><br>
            in total
          </div>
        </div>
      </div>
    </div>
  </div>  
  <div class="row">
    <div class="col">
      <div class="date-time-text">
        <aside></aside> as at {{dateAccessedString}}
      </div>
    </div>
  </div>
  <app-line-graph2></app-line-graph2>
</mat-card-content>